import { render, staticRenderFns } from "./shopCat.vue?vue&type=template&id=0331f056&scoped=true"
import script from "./shopCat.vue?vue&type=script&lang=js"
export * from "./shopCat.vue?vue&type=script&lang=js"
import style0 from "./shopCat.vue?vue&type=style&index=0&id=0331f056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0331f056",
  null
  
)

export default component.exports